<template>
  <div>
    <!-- <Card dis-hover> -->
    <div class="yearWrap">
      <div class="username">
        欢迎回来，{{name}}。
      </div>
      <div class="yearList">
        <span class="wall " v-for="(item,index) in yearList" :key="index">
          <span :class="item==year? 'year pointer se':'year pointer'" @click="changYear(item)">{{item=='All'?'全部数据':item}}</span>
        </span>
      </div>
    </div>
    <!-- </Card> -->
    <div class="top">
      <!-- 1平台邀请人数 -->
      <div class="topPage">
        <div class="card_page">
          <div class="info">
            <!-- 数量 -->
            <div class="left">
              <div class="title">平台邀请人数</div>
              <div @click="openUserModel('平台邀请明细',$homeTab.平台邀请人数)" class="num pointer">{{topPage.userBindModel.inviteCount}}</div>

            </div>
            <!-- 图标 -->
            <div class="right">
              <span class="icon pointer" @click="openPage('userUser')">
                <Icon type="md-person-add" size="25" color="#6d61ea" />
              </span>
            </div>
          </div>
          <!-- 信息 -->
          <div class="infonum">
            <span class="t">账号冻结：</span>
            <span @click="openUserModel('账号冻结明细',$homeTab.账号冻结)" class="n pointer">{{topPage.userBindModel.freezeCount}} 人</span>
            <span class="t">未续约：</span>
            <span @click="openUserModel('未续约明细',$homeTab.未续约)" class="n pointer">{{topPage.userBindModel.noRenewalCount}} 人</span>
          </div>
        </div>
      </div>
      <!-- 2平台注册人数 -->
      <div class="topPage">
        <div class="card_page">
          <div class="info">
            <!-- 数量 -->
            <div class="left">
              <div class="title">平台注册人数</div>
              <div @click.stop="openUserModel('平台注册明细',$homeTab.平台注册人数)" class="num pointer">{{topPage.userInfoModel.registerCount}} <span class="n">平台注册率：{{topPage.userInfoModel.registerRate}}%</span></div>
            </div>
            <!-- 图标 -->
            <div class="right">
              <span class="icon pointer" @click="openPage('userInfo')">
                <!-- <Icon type="md-person-add" size="25" color="#6d61ea" /> -->
                <Icon type="md-people" size="25" color="#6d61ea" />
                <!-- <Icon type="ios-people-outline"  size="25" color="#6d61ea"/> -->
              </span>
            </div>
          </div>
          <!-- 信息 -->
          <div class="infonum">
            <span class="t">未注册：</span>
            <span @click="openUserModel('未注册明细',$homeTab.未注册)" class="n pointer">{{topPage.userInfoModel.noRegisterCount}} 人</span>
            <span class="t">未领卡：</span>
            <span @click="openUserModel('卡包未领明细',$homeTab.未领卡)" class="n pointer">{{topPage.userInfoModel.noReceiveCardCount}} 人</span>
          </div>
        </div>
      </div>
      <!-- 3兑换积分数量 -->
      <div class="topPage">
        <div class="card_page">

          <div class="info">
            <!-- 数量 -->
            <div class="left">
              <div class="title">兑换积分数量</div>
              <div class="num">{{topPage.pointModel.totalPoint}}</div>
            </div>
            <!-- 图标 -->
            <div class="right">
              <span class="icon pointer" @click="openPage('commodity')">
                <Icon type="md-basket" size="25" color="#6d61ea" />
                <!-- <Icon type="ios-basket-outline"  size="25" color="#6d61ea" /> -->
              </span>
            </div>
          </div>
          <!-- 信息 -->
          <div class="infonum">
            <span class="t">平台订单数量：</span>
            <span class="n">{{topPage.pointModel.orderCount}} 单</span>
            <Dropdown>
              <span class="t pointer hover">+ 查看详细
                <Icon type="ios-arrow-down" size="12" />
              </span>
              <template #list>
                <DropdownMenu>
                  <DropdownItem>健康订单：{{topPage.pointModel.orderDetail.healthOrderCount}} 单，健康积分：{{topPage.pointModel.orderDetail.healthPointCount}} 分</DropdownItem>
                  <DropdownItem>书刊订单：{{topPage.pointModel.orderDetail.bookOrderCount}} 单，书刊积分：{{topPage.pointModel.orderDetail.bookPointCount}} 分 </DropdownItem>
                  <DropdownItem>文娱订单：{{topPage.pointModel.orderDetail.joyOrderCount}} 单，文娱积分：{{topPage.pointModel.orderDetail.joyPointCount}} 分</DropdownItem>
                  <DropdownItem>机场订单：{{topPage.pointModel.orderDetail.airportOrderCount}} 单，机场人次：{{topPage.pointModel.orderDetail.airportPointCount}} 人次</DropdownItem>
                </DropdownMenu>
              </template>
            </Dropdown>
          </div>
        </div>
      </div>
      <!-- 4 助理注冊 -->
      <div class="topPage">
        <div class="card_page">
          <div class="info">
            <!-- 数量 -->
            <div class="left">
              <div class="title">助理注册人数</div>
              <div class="num">{{topPage.assistantModel.assistantCount}}</div>

            </div>
            <!-- 图标 -->
            <div class="right">
              <span class="icon">
                <!-- <Icon type="logo-buffer" size="25" color="#6d61ea" /> -->
                <Icon type="md-git-compare" size="25" color="#6d61ea" />
              </span>
            </div>
          </div>

        </div>
      </div>

    </div>
    <div class="content">
      <div class="contentPage">
        <div class="card_page">
          <!-- 柱状图 积分品类兑换情况 -->
          <div class="title">积分品类兑换情况</div>
          <div id="corver"></div>
        </div>
      </div>
      <div class="contentPage">
        <div class="card_page">
          <!-- 业务明细情况 -->
          <div class="title">业务明细情况</div>
          <div class="grid">
            <div class="container">
              <!-- 选项 item -->
              <!-- 1 机场VIP -->
              <div class="item">
                <div class="i">
                  <Icon type="ios-jet" size="25" color="#6d61ea" />

                </div>
                <div class="t">机场VIP</div>
              </div>
              <div class="item">
                <div class="i"> {{business.airportUsedCount}}</div>
                <div class="t">已经使用人次</div>
              </div>
              <div class="item">
                <div class="i c pointer" @click="openPage('airport')">
                  {{business.airportOrderCount}}
                </div>
                <div class="t">待处理订单数</div>
              </div>
              <!-- 2好书不倦 -->
              <div class="item">
                <div class="i">
                  <Icon type="ios-book" size="25" color="#6d61ea" />
                </div>
                <div class="t">好书不倦</div>
              </div>
              <div class="item">
                <div class="i">
                  {{business.bookUsedCount}}
                </div>
                <div class="t">完成订单数量</div>
              </div>
              <div class="item">
                <div class="i pointer">
                  {{business.bookOrderCount}}
                </div>
                <div class="t">待发货订单</div>
              </div>
              <!-- 3文艺荟萃 -->
              <div class="item">
                <div class="i">
                  <Icon type="ios-camera" size="25" color="#6d61ea" />
                </div>
                <div class="t">文艺荟萃</div>
              </div>
              <div class="item">
                <div class="i">
                  {{business.joyUsedCount}}
                </div>
                <div class="t">完成订单数量</div>
              </div>
              <div class="item">
                <div class="i pointer">
                  {{business.joyOrderCount}}
                </div>
                <div class="t">待发货订单</div>
              </div>
              <!-- 4缤纷活动 -->
              <div class="item">
                <div class="i">
                  <Icon type="md-aperture" size="25" color="#6d61ea" />
                </div>
                <div class="t">缤纷活动</div>
              </div>
              <div class="item">
                <div class="i pointer" @click="openPage('article')">
                  {{business.articleCount}}
                </div>
                <div class="t">文章发布数量</div>
              </div>
              <div class="item">
                <div class="i pointer" @click="openPage('activity')">
                  {{business.activityCount}}
                </div>
                <div class="t">活动发布数量</div>
              </div>
              <!-- 5商城情况 -->
              <div class="item">
                <div class="i">
                  <Icon type="md-basket" size="25" color="#6d61ea" />
                </div>
                <div class="t">商城情况</div>
              </div>
              <div class="item">
                <div class="i pointer" @click="openPage('supplier')">
                  {{business.shopUsedCount}}
                </div>
                <div class="t">供应商开通数量</div>
              </div>
              <div class="item">
                <div class="i pointer" @click="openPage('commodity')">
                  {{business.shopOrderCount}}
                </div>
                <div class="t">当前上架商品</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom">
      <!-- 最近活动发布 -->
      <div class="bottomPage">
        <div class="card_page">
          <div class="title">
            <div class="l">最近活动发布 （最近5条）</div>
            <div class="r pointer" @click="openPage('activity')">
              <Icon type="ios-arrow-forward" size="20" />
            </div>
          </div>
          <div>
            <div class="row pointer" v-for="(item,index) in activitList.articleList" :key="index" @click="openPage('activity')">
              <!-- 信息 -->
              <div class="l">
                <img class="image" :src="url+item.articleBanner" width="50" height="50" />
                <div class="info">
                  <!-- 标题 -->
                  <div class="t">{{item.articleName}}</div>
                  <!-- 副标题 -->
                  <div class="st">{{item.articleSubName}}</div>
                </div>
              </div>
              <!-- 日期 -->
              <div>
                {{item.addTimeText}}
              </div>
            </div>
          </div>
          <div class="count">
            <div class="n">{{activitList.articleCount}}</div>
            <div class="t">活动发布数量</div>
          </div>
        </div>
      </div>
      <!-- 协同委派概览 -->
      <div class="bottomPage">
        <div class="card_page">
          <div class="title">
            <div class="l">协同委派概览 （最近8条）</div>
            <div class="r pointer" @click="openPage('collaborativeManagement')">
              <Icon type="ios-arrow-forward" size="20" />
            </div>
          </div>
          <div class="tab">
            <Table :loading="loading" :columns="columns" no-data-text="暂无数据" :data="data.entrustList"></Table>
          </div>
          <div class="countWrap">
            <div class="count">
              <div class="n">{{data.unHandleCount}}</div>
              <div class="t">待处理申请</div>
            </div>
            <div class="count">
              <div class="n">{{data.handleingCount}}</div>
              <div class="t">委办处理中</div>
            </div>
            <div class="count">
              <div class="n">{{data.handleFinishCount}}</div>
              <div class="t">已完成处理</div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <!-- 信息弹框 -->
    <Modal v-model="userModel" class="userModel" :title="modelTitle">
      <p>此处名单仅作参考,具体内容请以具体功能页面为准。</p>
      <div class="modelTab">
        <Table :loading="loading" :columns="userColumns" no-data-text="暂无数据" :data="userData"></Table>
      </div>
      <template #footer>
        <span></span>
      </template>
    </Modal>
  </div>
</template>
<script>
import url from '../../lib/url'
export default {
  data() {
    return {
      loading: false,
      userModel: false,
      modelTitle: '',
      url: url,
      name:'',
      yearList: ['All'],
      year: 'All',
      topPage: {
        assistantModel: { freezeCount: 0, inviteCount: 0, noRenewalCount: 0 },
        pointModel: { orderCount: 0, orderDetail: 0, totalPoint: 0 },
        userBindModel: { freezeCount: 8, inviteCount: 20, noRenewalCount: 0 },
        userInfoModel: {
          noReceiveCardCount: 0,
          noRegisterCount: 0,
          registerCount: 0,
          registerRate: 0,
        },
      },
      business: {},
     
      activitList: {
        articleCount: null,
        articleList: [],
      },
      userColumns: [
        {
          title: '用户姓名',
          key: 'name',
          tooltip: true,
        },
        {
          title: '用户卡号',
          key: 'cardCode',
          tooltip: true,
        },
        {
          title: '用户手机',
          key: 'phone',
          tooltip: true,
        },
      ],
      userData: [
        {
          name: 'John Brown',
          age: 18,
          address: 'New York No. 1 Lake Park',
          date: '2016-10-03',
        },
        {
          name: 'Jim Green',
          age: 24,
          address: 'London No. 1 Lake Park',
          date: '2016-10-01',
        },
        {
          name: 'Joe Black',
          age: 30,
          address: 'Sydney No. 1 Lake Park',
          date: '2016-10-02',
        },
        {
          name: 'Jim Green',
          age: 24,
          address: 'London No. 1 Lake Park',
          date: '2016-10-01',
        },
        {
          name: 'Joe Black',
          age: 30,
          address: 'Sydney No. 1 Lake Park',
          date: '2016-10-02',
        },
        {
          name: 'Jim Green',
          age: 24,
          address: 'London No. 1 Lake Park',
          date: '2016-10-01',
        },
        {
          name: 'Joe Black',
          age: 30,
          address: 'Sydney No. 1 Lake Park',
          date: '2016-10-02',
        },
        {
          name: 'Jim Green',
          age: 24,
          address: 'London No. 1 Lake Park',
          date: '2016-10-01',
        },
        {
          name: 'Joe Black',
          age: 30,
          address: 'Sydney No. 1 Lake Park',
          date: '2016-10-02',
        },
        {
          name: 'Jim Green',
          age: 24,
          address: 'London No. 1 Lake Park',
          date: '2016-10-01',
        },
        {
          name: 'Joe Black',
          age: 30,
          address: 'Sydney No. 1 Lake Park',
          date: '2016-10-02',
        },
        {
          name: 'Jim Green',
          age: 24,
          address: 'London No. 1 Lake Park',
          date: '2016-10-01',
        },
        {
          name: 'Joe Black',
          age: 30,
          address: 'Sydney No. 1 Lake Park',
          date: '2016-10-02',
        },
        {
          name: 'Jim Green',
          age: 24,
          address: 'London No. 1 Lake Park',
          date: '2016-10-01',
        },
        {
          name: 'Joe Black',
          age: 30,
          address: 'Sydney No. 1 Lake Park',
          date: '2016-10-02',
        },
      ],
      data: { entrustList: [], handleFinishCount: 5, handleingCount: 7, unHandleCount: 4 },
      columns: [
        {
          title: '协同服务申请',
          key: 'serviceTitle',
          tooltip: true,
        },
        {
          title: '申请时间',
          key: 'addTimeText',
          tooltip: true,
        },
        {
          title: '专家姓名',
          key: 'name',
          tooltip: true,
        },
        {
          title: '服务机构',
          key: 'organizationName',
          tooltip: true,
        },
        {
          title: '当前状态',
          key: 'entrustStateText',
          tooltip: true,
        },
      ],
      queryForm: {
        year: '',
      },
    }
  },
  created() {
    let arr = this.getYaer(2018)
    // this.url=url
    this.yearList = this.yearList.concat(arr)
    this.getData()
  },

  methods: {
    //
    getYaer(val) {
      // 获取指定年份开始到现在年份的数组
      //获取到从那一年开始
      let timList = []
      let smallYears = val

      let date = new Date() //获取当前时间
      let NowYears = date.getFullYear() //当前年
      var Years = NowYears - smallYears
      let arrTim = []
      // for (let index = 0; index <= Years; index++) {
      //   arrTim.push(NowYears--)//[2023,2022,2021]
      // }
      for (let index = 0; index <= Years; index++) {
        arrTim.push(val++) //[2021,2022,2023]
      }
      arrTim.forEach((tim) => {
        timList.push(tim)
      })
      return timList
    },
    //   获取信息
    async getData() {
      this.loading = true
      let { data } = await this.$Ajax.get(
        `/api/services/app/GetIndexService/HomeIndex?year=${this.year}`
      )

      let allData = data.result.indexModel
      this.topPage = allData.box1
      let d = allData.box2
      this.activitList = allData.box4
      this.business = allData.box3
      this.data = allData.box5
      this.name=data.result.name
      var chart = Highcharts.chart('corver', {
        chart: {
          type: 'column',
        },
        title: {
          text: '',
        },
        credits: {
          enabled: false,
        },
        xAxis: {
          categories: ['健康订单', '书刊订单', '文娱订单', '机场订单'],
        },
        yAxis: [
          {
            min: 0,
            title: {
              text: '订单数量',
            },
          },
        ],
        legend: {
          shadow: false,
        },
        tooltip: {
          shared: true,
        },
        plotOptions: {
          column: {
            grouping: false,
            shadow: false,
            borderWidth: 0,
          },
        },
        series: [
          {
            name: '订单数量',
            color: 'rgba(165,170,217,1)',
            data: [d.healthOrderCount, d.bookOrderCount, d.joyOrderCount, d.airportOrderCount],
            pointPadding: 0.3,
          },
        ],
      })
      this.loading = false
    },
    // 打开弹框
    async openUserModel(title,dataType) {
      this.modelTitle = title
      let { data } = await this.$Ajax.get('/api/services/app/GetIndexService/GetDataList', {
        params:{dataType,year:this.year},
      })
      this.userData=data.result
      this.userModel = true
    },
    changYear(item) {
      this.year = item
      this.getData()
    },
    // 打开页面
    openPage(name) {
      this.$router.push({
        name: name,
        // params: { id: 0 },
      })
    },
  },
}
</script>

<style scoped media="screen" lang="less">
.username{
font-weight: 900;
font-size: 18px;
}
.yearWrap {
  display: flex;
  justify-content: space-between;
  .year {
    display: inline-block;
    padding: 0 5px;
    font-size: 14px;
  }
  .se {
    color: #fff;
    background: #6d61ea;
    padding: 0 15px;
    border-radius: 3px;
    font-weight: bold;
  }
  .wall {
    display: inline-block;
    padding: 0 5px;
  }
  .wall::after {
    content: '|';
    display: inline-block;
    padding-left: 10px;
    position: relative;
    top: -2px;
    background: 240, 242, 245;
  }
  .wall:nth-last-of-type(1)::after {
    content: '';
  }
}
.top {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.pointer {
  cursor: pointer;
}
.hover {
  border-radius: 5px;
  padding: 2px 2px;
}
.hover:hover {
  border: 2px solid #49505742;
}
.topPage {
  //   width: 24%;
  margin-top: 20px;
  .n {
    display: inline-block;
    margin: 0px 10px;
    color: #6d61ea;
    background-color: rgba(109, 97, 234, 0.18);
    padding: 1px 5px;
    border-radius: 5px;
    font-weight: bold;
    font-size: 12px;
    font-family: 'Montserrat', sans-serif;
    // font-weight: normal;
  }
  .info {
    display: flex;
    justify-content: space-between;

    .left {
      .title {
        font-size: 15px;
        font-weight: bold;
        color: #6c757d;
      }
      .num {
        font-size: 22px;
        font-weight: bold;
        color: #495057;
        margin-top: 4px;
        white-space: nowrap;
        font-family: 'Montserrat', sans-serif;
      }
    }
    .right {
      .icon {
        display: inline-block;
        width: 42px;
        height: 42px;
        text-align: center;
        line-height: 48px;
        border-radius: 50%;
        background: rgba(109, 97, 234, 0.18);
      }
    }
    .infonum {
      white-space: nowrap;
    }
    .t {
      font-size: 13px;
      color: #6c757d;
    }
  }
}
.card_page {
  background: #fff;
  box-shadow: 0 0 17px 0 rgba(130, 122, 122, 0.1);
  border-radius: 8px;
  font-size: 14px;
  position: relative;
  transition: all 0.2s ease-in-out;
  padding: 20px;
  min-height: 130px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
.card_page:hover {
  transform: scale(1.01);
  z-index: 100;
    box-shadow: 0 0 17px 0 rgba(130, 122, 122, 0.4);
}
.content {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .title {
    font-size: 15px;
    padding: 0px 0px 10px 0px;
    font-weight: bold;
  }
  #corver {
    height: 400px;
  }
  .contentPage {
    margin-top: 20px;
  }
  /*   .contentPage:nth-of-type(1) {
    min-width: 63.5%;
  }
  .contentPage:nth-of-type(2) {
    min-width: 35%;
  } */
  .container {
    height: 400px;
    width: 100%;
    /* 设置容器布局为grid布局 */
    display: grid;
    /* 宽度平均分成4份 */
    grid-template-columns: repeat(3, 1fr);
    /* 高度平均分成3份 */
    grid-template-rows: repeat(5, 1fr);
    // background: cornflowerblue;
    // gap: 20px 20px;
    justify-items: stretch;
    align-items: stretch;
    /* 但是容器的大小不确定，这个属性就会自动填充 */
    // grid-template-columns: repeat(auto-fill,100px);
    /* 指定每一行的宽度 每个宽度中间用空格隔开 */
    // grid-template-rows:100px 100px 100px;
    /* 指定每一列的宽度 每个宽度中间用空格隔开 */
    // grid-template-columns:100px 100px 100px;
    .item {
      //   background: cornflowerblue;
      border-bottom: 1px solid #e9edf3;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .i {
        font-size: 21px;
        font-weight: bold;
        padding: 5px;
      }
      .t {
        padding: 5px;
      }
      .c {
        color: #6d61ea;
      }
    }
    .item:nth-of-type(n + 13) {
      border: none;
    }
  }
}
.bottom {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .bottomPage {
    margin-top: 20px;
    .title {
      display: flex;
      justify-content: space-between;
      font-size: 15px;
      font-weight: bold;
      color: #6c757d;
      //   padding: 10px 0px;
      padding-bottom: 10px;
    }
    .row {
      border-bottom: 1px solid #e9edf3;
      display: flex;
      justify-content: space-between;
      padding: 10px 0px;
    }
    .l {
      .info {
        margin-left: 10px;
        .t {
          font-weight: bold;
        }
      }
      display: flex;
      .image {
        border-radius: 50%;
      }
    }
    .countWrap {
      display: flex;
      justify-content: space-evenly;
    }
    .count {
      text-align: center;
      margin-top: 20px;

      .n {
        font-size: 24px;
      }
      .t {
        color: #575757;
      }
    }
  }
  /*   .bottomPage:nth-of-type(1) {
    width: 35%;
  }
  .bottomPage:nth-of-type(2) {
    width: 63.5%;
  } */
}
// /deep/.ivu-modal-content{

// }
.modelTab {
  margin-top: 10px;

  max-height: 500px;
  overflow: auto;
  /deep/.ivu-table {
    border-top: 1px solid #e8eaec;
  }
}
/deep/.ivu-modal-footer {
  display: none;
}
@media screen and (max-width: 100800px) {
  .topPage {
    width: 24%;
  }
  .contentPage:nth-of-type(1) {
    width: 63.5%;
  }
  .contentPage:nth-of-type(2) {
    width: 35%;
  }
  .bottomPage:nth-of-type(1) {
    width: 35%;
  }
  .bottomPage:nth-of-type(2) {
    width: 63.5%;
  }
}
@media screen and (max-width: 1550px) {
  .topPage {
    width: 48%;
  }
  .contentPage:nth-of-type(1) {
    width: 63.5%;
  }
  .contentPage:nth-of-type(2) {
    width: 35%;
  }
  .bottomPage:nth-of-type(1) {
    width: 35%;
  }
  .bottomPage:nth-of-type(2) {
    width: 63.5%;
  }
}
@media screen and (max-width: 1350px) {
  .topPage {
    width: 48%;
  }
  .contentPage:nth-of-type(1) {
    width: 100%;
  }
  .contentPage:nth-of-type(2) {
    width: 100%;
  }
  .bottomPage:nth-of-type(1) {
    width: 100%;
  }
  .bottomPage:nth-of-type(2) {
    width: 100%;
  }
}
@media screen and (max-width: 1000px) {
  .topPage {
    width: 100%;
  }
  .contentPage:nth-of-type(1) {
    width: 100%;
  }
  .contentPage:nth-of-type(2) {
    width: 100%;
  }
  .bottomPage:nth-of-type(1) {
    width: 100%;
  }
  .bottomPage:nth-of-type(2) {
    width: 100%;
  }
}
</style>
